module.exports = __webpack_public_path__ + "static/media/iconfinder_map-marker_285659.6dfeaf0f.png";